import { CBLanguageService, LanguageValues } from "cbcore-ts"
import { UICore } from "uicore-ts"


export class LanguageService extends CBLanguageService {
    
    static override languageValues: LanguageValues = {
        
        en: {
            
            languageName: "English",
            languageNameShort: "ENG",
            
            topBarTitle: "Riigihangete registri statistika (Beta)",
            
            selectLanguageTitle: "Select language",
            leftBarTitle: "Title",
            
            numberOfProcurementsStarted: "Avaldatud hankeid",
            numberOfProcurementLots: "Hankeosi",
            averageNumberOfOffersPerProcurementLotNotice: "Keskmine pakkumuste arv hankeosa kohta",
            numberOfProcurementLotsWithNoOffers: "Pakkumusteta hankeosi",
            numberOfContractsForTheYear: "Sõlmitud lepinguid",
            contractMonetarySum: "Lepingute kogumaht",
            numberOfContractsWithOneOffer: "Lepinguid 1 pakkumusega hankeosades",
            numberOfContractsWithTwoOffers: "Lepinguid 2 pakkumusega hankeosades",
            numberOfContractsWithAtLeastThreeOffers: "Lepinguid vähemalt 3 pakkumusega hankeosades",
            averageNumberOfOffersPerContract: "Keskmine pakkumuste arv lepingu kohta",
            numberOfUnannouncedProcurementContractOverviews: "Väljakuulutamiseta läbirääkimistega hankemenetlusi",
            averageLengthOfProcurementBeforeContractSigningInDays: "Keskmine menetluse kestus (päevades)"
            
            
        },
        est: {
            
            languageName: "Eesti keel",
            languageNameShort: "EST",
            
            topBarTitle: "Riigihangete registri statistika (Beta)",
            RHRStatisticsViewControllerTitle_offerer: "Riigihangete registri statistika - lepingupartnerid",
            RHRStatisticsViewControllerTitle_procurer: "Riigihangete registri statistika - hankija",
            
            RHRStatisticsComparisonViewControllerTitle_offerer: "Riigihangete registri statistika - lepingupartnerite võrdlus",
            RHRStatisticsComparisonViewControllerTitle_procurer: "Riigihangete registri statistika - hankijate võrdlus",
            
            selectLanguageTitle: "Vali keel",
            leftBarTitle: "Pealkiri",
            
            procurerName: "Hankija",
            offerersDataWithCount: "Lepingupartnerid (tk)",
            offerersDataWithMonetarySum: "Lepingupartnerid (€)",
            averageNumberOfOffersPerProcurementLotNotice: "Keskmine pakkumuste arv hankeosa kohta",
            numberOfProcurementLotsWithNoOffers: "Pakkumusteta hankeosi",
            numberOfContractsWithOneOffer: "Lepinguid 1 pakkumusega hankeosades",
            numberOfContractsWithTwoOffers: "Lepinguid 2 pakkumusega hankeosades",
            numberOfContractsWithAtLeastThreeOffers: "Lepinguid vähemalt 3 pakkumusega hankeosades",
            averageNumberOfOffersPerContract: "Keskmine pakkumuste arv lepingu kohta",
            numberOfUnannouncedProcurementContractOverviews: "Väljakuulutamiseta läbirääkimistega hankemenetlusi",
            averageLengthOfProcurementBeforeContractSigningInDays: "Keskmine menetluse kestus (päevades)",

//Hankija võrdlus:
            searchableDropdownNotSelected: "valik tegemata",
            numberOfContractsForTheYear: "Sõlmitud lepinguid",
            contractMonetarySum: "Lepingute kogumaht",
            numberOfProcurementsStarted: "Alustatud hankeid",
            numberOfProcurementLots: "Hankeosi",
            numberOfProcurementLotsWithAtleastThreeOffers: "Vähemalt 3 pakkumusega hankeosi",


//Pakkuja andmed: (2 esimest välja ei kuva andmeid)
            offererName: "Lepingupartner",
            procurersDataWithCount: "Hankijad (tk)",
            procurersDataWithMonetarySum: "Hankijad (€)",
            // numberOfContractsForTheYear: "Sõlmitud lepinguid",
            // contractMonetarySum: "Lepingute kogumaht",
            numberOfContractsWonForTheYear: "Sõlmitud lepinguid",
//          NB! võiks lisada ka selle dumpingu indeksi
//          Keskmine pakkumuste arv lepingu kohta - MAHA        
//          numberOfContractsWonWithOneOffer - MAHA
//          numberOfContractsWonWithTwoOffers - MAHA
//          numberOfContractsWonWithAtLeastThreeOffers - MAHA
            numberOfUnannouncedProcurementContractOverviewsWonByOfferer: "Väljakuulutamiseta läbirääkimistega hankemenetlusi",
//          Keskmine menetluse kestus (päevades) - MAHA


//Pakkuja võrdlus:
            
            
            
            bottomBarContent: "<!— ⬇️ Footer algus -->\n" +
                "                <footer class=\"site-footer\">\n" +
                "            Küsimuste ja ettepanekute korral <strong>palun kirjutage</strong>&nbsp;\n" +
                "                <a href=\"mailto:info@rhr.ee\">info@rhr.ee</a>\n" +
                "            %UPDATE_TIME_STRING%" +
                "                </footer>\n" +
                "                \n" +
                "                <style>\n" +
                "            .site-footer {\n" +
                "    background: #f5f5f7;\n" +
                "    color: #4b4b4b;\n" +
                "    padding: 1rem;\n" +
                "    font-size: 0.9rem;\n" +
                "    height: 100%; \n" +
                "    text-align: center;\n" +
                "}\n" +
                "\n" +
                ".site-footer a {\n" +
                "    color: #0068c4;\n" +
                "    text-decoration: none;\n    " +
                "}\n" +
                "\n" +
                ".site-footer a:hover {\n" +
                "    text-decoration: underline;\n" +
                "}\n" +
                "</style>\n" +
                "<!-- ⬆️ Footer lõpp -->\n"
            
            
        }
        
        
    }
    
    
}


CBLanguageService.currentClassObject = LanguageService
LanguageService.useStoredLanguageValues({})
UICore.languageService = LanguageService




























